import { render, staticRenderFns } from "./EventSeries.vue?vue&type=template&id=c1fb3b20&scoped=true"
import script from "./EventSeries.vue?vue&type=script&lang=js"
export * from "./EventSeries.vue?vue&type=script&lang=js"
import style0 from "./EventSeries.vue?vue&type=style&index=0&id=c1fb3b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fb3b20",
  null
  
)

export default component.exports